import getPageSpec from './getPageSpec.js';
import mergeSpec from '../spec/mergeSpec.js';

/**
 * Gets and merges page specification properties.
 * Extends the placeholder with custom data that override
 * the default values from the template.
 * @param {object} page Parabo original page data
 * @param {object} [opts]
 * @param {object} [opts.override] Override to apply if the default override shouldn't be used.
 * @param {object} [opts.style] Style to apply
 * @returns {object} Subset of Parabo page without the basic values.
 * Only the values that can be overridden are returned.
 */
const mergePageSpec = (page, { override = page.override, style } = {}) => {
  const pageSpec = getPageSpec(page);
  const overrideSpec = override == null ? undefined : getPageSpec(override);
  const styleSpec = style == null ? undefined : getPageSpec(style);
  return mergeSpec(pageSpec, { overrideSpec, styleSpec });
};

export default mergePageSpec;
